import BaseModel from '../core/BaseModel'
export default class ReportComparisonAgencyModel extends BaseModel {

    constructor() {
        super({
            name: "repportcomparisonagency",
            tableName: 'office_agency',
            label: "Báo cáo VB tổng hợp các CQ",
            display_key: 'name', 
            default_order: { key: 'id', direction: 'asc' }
        },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    width: 4,
                    class: "center",
                    computed: (data) => {
                        data.stt = data.sttKey;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                agency_tpl_key: {
                    name: 'agency_tpl_key',
                    type: "String",
                    label: 'Mã văn phòng quản lý',
                    width: 8,
                    class: "center",
                    filter: { type: 'input', match: 'contains' },
                    computed: (data) => {
                        data.agency_tpl_key = data.agency_tpl || '';
                    }
                },
                code: {
                    name: 'code', 
                    type: "String",
                    label: 'Mã cơ quan',
                    width :15,
                    class: "center", 
                    filter: { type: 'input', match: 'contains'},
                    // display: false
                },
                name: {
                    name: 'name', 
                    type: "String",
                    label: 'Tên cơ quan',
                    width :15, 
                    filter: { type: 'input', match: 'contains'},
                    // display: false
                },
                name_no_diacritics : {
                    name: 'name_no_diacritics',
                    type: "String",
                    label: 'Tên không dấu',
                    width: 15,
                    //filter: { type: 'input', match: 'contains' },
                    display: false
                },
                // tổng số VB theo từng loại 1-4 mà TPHCM nhận
                count_document_city_received_type1: {
                    name: 'count_document_city_received_type1',
                    type: "Int",
                    label: 'Tổng VB loại 1 TPHCM nhận',
                    width: 8,
                    class: "center",
                    computed: (data) => {
                        data.count_document_city_received_type1 = data.count_document_city_received_type1 || 0;
                    }
                },
                count_document_city_received_type2: {
                    name: 'count_document_city_received_type2',
                    type: "Int",
                    label: 'Tổng VB loại 2 TPHCM nhận',
                    width: 8,
                    class: "center",
                    computed: (data) => {
                        data.count_document_city_received_type2 = data.count_document_city_received_type2 || 0;
                    }
                },
                count_document_city_received_type3: {
                    name: 'count_document_city_received_type3',
                    type: "Int",
                    label: 'Tổng VB loại 3 TPHCM nhận',
                    width: 8,
                    class: "center",
                    computed: (data) => {
                        data.count_document_city_received_type3 = data.count_document_city_received_type3 || 0;
                    }
                },
                count_document_city_received_type4: {
                    name: 'count_document_city_received_type4',
                    type: "Int",
                    label: 'Tổng VB loại 4 TPHCM nhận',
                    width: 8,
                    class: "center",
                    computed: (data) => {
                        data.count_document_city_received_type4 = data.count_document_city_received_type4 || 0;
                    }
                },
                // tổng số văn bản thành phố (TPHCM, THỦ ĐỨC) nhận
                count_document_city_received: {
                    name: 'count_document_city_received',
                    type: "Int",
                    label: 'Tổng số VB TPHCM nhận',
                    width: 8,
                    class: "center",
                    //filter: { type: 'input', match: 'contains' },
                    computed: (data) => {
                        data.count_document_city_received = data.count_document_city_received || 0;
                    }
                },
                // tổng số văn bản thành phố (TPHCM, THỦ ĐỨC) trả tòa
                count_document_city_return_court: {
                    name: 'count_document_city_return_court',
                    type: "Int",
                    label: 'Tổng số VB TPHCM trả tòa',
                    width: 8,
                    class: "center",
                    //filter: { type: 'input', match: 'contains' },
                    computed: (data) => {
                        data.count_document_city_return_court = data.count_document_city_return_court || 0;
                    }
                },
                //total number of outstanding documents
                count_document_city_outstanding: {
                    name: 'count_document_city_outstanding',
                    type: "Int",
                    label: 'Tổng số VB TPHCM tồn',
                    width: 8,
                    class: "center",
                    //filter: { type: 'input', match: 'contains' },
                    computed: (data) => {
                        data.count_document_city_outstanding = data.count_document_city_outstanding || 0;
                    }
                },
                // tổng số văn bản tỉnh thành nhận
                count_document_province_received: {
                    name: 'count_document_province_received',
                    type: "Int",
                    label: 'Tổng số VB Tỉnh nhận',
                    width: 8,
                    class: "center",
                    //filter: { type: 'input', match: 'contains' },
                    computed: (data) => {
                        data.count_document_province_received = data.count_document_province_received || 0;
                    }
                },
                // tổng số văn bản tỉnh thành trả tòa
                count_document_province_return_court: {
                    name: 'count_document_province_return_court',
                    type: "Int",
                    label: 'Tổng số VB Tỉnh trả tòa',
                    width: 8,
                    class: "center",
                    //filter: { type: 'input', match: 'contains' },
                    computed: (data) => {
                        data.count_document_province_return_court = data.count_document_province_return_court || 0;
                    }
                },
                //total number of outstanding documents
                count_document_province_outstanding: {
                    name: 'count_document_province_outstanding',
                    type: "Int",
                    label: 'Tổng số VB tỉnh tồn',
                    width: 8,
                    class: "center",
                    //filter: { type: 'input', match: 'contains' },
                    computed: (data) => {
                        data.count_document_province_outstanding = data.count_document_province_outstanding || 0;
                    }
                },
                // tiền VB nhận của thành phố
                money_city_received: {
                    name: 'money_city_received',
                    type: "Currency",
                    label: 'Số tiền VB TPHCM nhận',
                    width: 8,
                    class: "center",
                    //filter: { type: 'input', match: 'contains' },
                    computed: (data) => {
                        data.money_city_received = data.money_city_received || 0;
                    }
                },
                // tiền VB trả tòa của thành phố
                money_city_return_court: {
                    name: 'money_city_return_court',
                    type: "Currency",
                    label: 'Số tiền VB TPHCM trả tòa',
                    width: 8,
                    class: "center",
                    //filter: { type: 'input', match: 'contains' },
                    computed: (data) => {
                        data.money_city_return_court = data.money_city_return_court || 0;
                    }
                },
                // tiền VB nhận của tỉnh thành
                money_province_received: {
                    name: 'money_province_received',
                    type: "Currency",
                    label: 'Số tiền VB Tỉnh nhận',
                    width: 8,
                    class: "center",
                    //filter: { type: 'input', match: 'contains' },
                    computed: (data) => {
                        data.money_province_received = data.money_province_received || 0;
                    }
                },
                // tiền VB trả tòa của tỉnh thành
                money_province_return_court: {
                    name: 'money_province_return_court',
                    type: "Currency",
                    label: 'Số tiền VB Tỉnh trả tòa',
                    width: 8,
                    class: "center",
                    // filter: { type: 'input', match: 'contains' },
                    computed: (data) => {
                        data.money_province_return_court = data.money_province_return_court || 0;
                    }
                },

                count_documents_returned_court: {
                    name: 'count_documents_returned_court',
                    type: "Int",
                    label: 'Tổng VB trả lại tòa (loại 4)',
                    width: 8,
                    class: "center",
                    //filter: { type: 'input', match: 'contains' },
                    computed: (data) => {
                        data.count_documents_returned_court = data.count_documents_returned_court || 0;
                    }
                },
               
            },)
    }

}